<template>
  <div id="app" class="min-h-screen bg-gray-100">
    <Navbar />
    <main class="container mx-auto mt-8 px-4">
      <PatientTable />
    </main>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { useDbStore } from './stores/dbStore';
import Navbar from './components/Navbar/Navbar.vue';
import PatientTable from './components/PatientTable.vue';

export default {
  name: 'App',
  async created() {
    const dbStore = useDbStore();
    await dbStore.fetchData();
  },
  components: {
    Navbar,
    PatientTable
  },
  setup() {
    const dbStore = useDbStore();

    onMounted(() => {
      dbStore.fetchData();
    });
  }
}
</script>